import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { EcommerceService } from '../ecommerce.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {

  public orderDetails: any;
  public items: any;
  public statuses = ['PENDING','IN_PROGRESS', 'READY', 'REJECTED', 'DELIVERED'];
  public orderStatusColor: any = {
      PENDING: '#867402',
      IN_PROGRESS: '#028639',
      READY: '#028681',
      DELIVERED: '#304fff',
      REJECTED: '#ff3030',
  }

  private statusLabels: { [key: string]: string } = {
    'IN_PROGRESS': 'Start',
    'REJECTED': 'Reject',
    'READY': 'Ready',
    'DELIVERED': 'Deliver',
  };

  public getStatusLabel(status: string): string {
    return this.statusLabels[status] || status;
  }

  public getAllowedStatusButtons(status: string): string[]{
    switch(status){
      case 'PENDING': return ['IN_PROGRESS','REJECTED'];
      case 'IN_PROGRESS': return ['READY'];
      case 'READY': return ['DELIVERED'];
      default: return [];
    }
  }

  constructor(public route: ActivatedRoute,
    public spinner: NgxSpinnerService,
    public service: EcommerceService) {
  }

  ngOnInit() {
    this.spinner.show();

    this.initOrderDetails(this.route.snapshot.params['id']);
  }

  public initOrderDetails(id: any) {
    this.service.getOrderById(id).subscribe(res => {
      this.orderDetails = res;
      this.service.getOrderItemsById(id).subscribe(res2 => {
        this.items = res2;
        this.spinner.hide();
      },
        error => {
          this.spinner.hide();
          console.log(error);
        });
    },
      error => {
        this.spinner.hide();
        console.log(error);
      });
  }

  goBack() {
    window.history.back();
  }

  public updateStatus(status: string) {
    if (status === this.orderDetails.status) {
      return;
    }

    this.spinner.show();
    const orderId = this.route.snapshot.params['id'];

    this.service.updateOrderStatus(orderId, status).subscribe(
      () => {
        this.orderDetails.status = status; // Update local state immediately
        this.initOrderDetails(orderId); // Refresh order details
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      }
    );
  }
}
